import * as React from 'react';

const CreditCardBackRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 192 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_13559_1742)">
            <path
                d="M0 16C0 7.16344 7.16344 0 16 0H176C184.837 0 192 7.16344 192 16V112C192 120.837 184.837 128 176 128H16C7.16344 128 0 120.837 0 112V16Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.37258 4 4 9.37258 4 16V112C4 118.627 9.37258 124 16 124H176C182.627 124 188 118.627 188 112V16C188 9.37258 182.627 4 176 4ZM16 0C7.16344 0 0 7.16344 0 16V112C0 120.837 7.16344 128 16 128H176C184.837 128 192 120.837 192 112V16C192 7.16344 184.837 0 176 0H16Z"
                fill="#E8E8E7"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50 74C50 72.8954 50.8954 72 52 72H56C57.1046 72 58 72.8954 58 74C58 75.1046 57.1046 76 56 76H52C50.8954 76 50 75.1046 50 74ZM52 73C51.4477 73 51 73.4477 51 74C51 74.5523 51.4477 75 52 75H56C56.5523 75 57 74.5523 57 74C57 73.4477 56.5523 73 56 73H52Z"
                fill="#D6CEC1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50 79C50 77.8954 50.8954 77 52 77H56C57.1046 77 58 77.8954 58 79C58 80.1046 57.1046 81 56 81H52C50.8954 81 50 80.1046 50 79ZM52 78C51.4477 78 51 78.4477 51 79C51 79.5523 51.4477 80 52 80H56C56.5523 80 57 79.5523 57 79C57 78.4477 56.5523 78 56 78H52Z"
                fill="#D6CEC1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M52 82C50.8954 82 50 82.8954 50 84C50 85.1046 50.8954 86 52 86H56C57.1046 86 58 85.1046 58 84C58 82.8954 57.1046 82 56 82H52ZM52 83C51.4477 83 51 83.4477 51 84C51 84.5523 51.4477 85 52 85H56C56.5523 85 57 84.5523 57 84C57 83.4477 56.5523 83 56 83H52Z"
                fill="#D6CEC1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60 74C60 72.8954 60.8954 72 62 72H66C67.1046 72 68 72.8954 68 74C68 75.1046 67.1046 76 66 76H62C60.8954 76 60 75.1046 60 74ZM62 73C61.4477 73 61 73.4477 61 74C61 74.5523 61.4477 75 62 75H66C66.5523 75 67 74.5523 67 74C67 73.4477 66.5523 73 66 73H62Z"
                fill="#D6CEC1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M62 77C60.8954 77 60 77.8954 60 79C60 80.1046 60.8954 81 62 81H66C67.1046 81 68 80.1046 68 79C68 77.8954 67.1046 77 66 77H62ZM62 78C61.4477 78 61 78.4477 61 79C61 79.5523 61.4477 80 62 80H66C66.5523 80 67 79.5523 67 79C67 78.4477 66.5523 78 66 78H62Z"
                fill="#D6CEC1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60 84C60 82.8954 60.8954 82 62 82H66C67.1046 82 68 82.8954 68 84C68 85.1046 67.1046 86 66 86H62C60.8954 86 60 85.1046 60 84ZM62 83C61.4477 83 61 83.4477 61 84C61 84.5523 61.4477 85 62 85H66C66.5523 85 67 84.5523 67 84C67 83.4477 66.5523 83 66 83H62Z"
                fill="#D6CEC1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44 24C39.5817 24 36 27.5817 36 32V96C36 100.418 39.5817 104 44 104H148C152.418 104 156 100.418 156 96V32C156 27.5817 152.418 24 148 24H44ZM48 72C48 70.8954 48.8954 70 50 70H68C69.1046 70 70 70.8954 70 72V86C70 87.1046 69.1046 88 68 88H50C48.8954 88 48 87.1046 48 86V72Z"
                fill="#D6CEC1"
            />
            <path d="M36 36H156V52H36V36Z" fill="#37322D" />
        </g>
        <defs>
            <clipPath id="clip0_13559_1742">
                <rect width="192" height="128" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

CreditCardBackRebrandingSvg.displayName = 'CreditCardBackRebrandingSvg';
export default CreditCardBackRebrandingSvg;
